import React from 'react';

import Swal from 'sweetalert2';
import { useSnackbar } from 'notistack';

import {
  Button,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { ConceptService } from '../../Services/concept.service';
import { useLoadingContext } from '../../context/loadingContext';

const Concept = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [concepts, setConcepts] = React.useState([]);
  const [name, setName] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [openBrand, setOpenBrand] = React.useState(false);
  const [editBrand, setEditBrand] = React.useState(false)
  const [conceptId, setConceptId] = React.useState('');
  const [brandName, setBrandName] = React.useState('');
  const [image, setImage] = React.useState();
  const [imageReview, setImageReview] = React.useState();
  const [editMode, setEditMode] = React.useState(false);
  const [idBrand, setIdBrand] = React.useState('');
  const [idConcept, setIdConcept] = React.useState('');
  const [url, setUrl] = React.useState('');
  const { handleStartLoading, handleStopLoading } = useLoadingContext()

  React.useEffect(() => {
    getConcept().finally(handleStopLoading);
  }, []);

  const getConcept = async () => {
    handleStartLoading()
    const conceptReturn = await ConceptService.GetPrivateConcept();
    setConcepts(conceptReturn);
  };

  const handleClose = () => {
    setOpen(false);
    setConceptId('');
    setName('');
    setBrandName('');
    setOpenBrand(false);
    setImage(null);
    setImageReview(null);
    setEditMode(false);
  };

  const handleCloseBrand = () => {
    setEditBrand(false);
    setBrandName('');
  };

  const handleCreateConceptClick = () => {
    setOpen(true);
  };

  const handleCreateConceptSubmit = () => {
    handleStartLoading()
    ConceptService.CreateConcept({ name }).then((res) => {
      setConcepts((prevState) => [...prevState, res]);
      setOpen(false);
    }).finally(handleStopLoading);
  };

  const handleCreateBrandClick = (idConcept) => {
    setOpenBrand(true);
    setConceptId(idConcept);
  };

  const handleEditClick = (id, name) => {
    setConceptId(id);
    setOpen(true);
    setName(name);
    setEditMode(true);
  };

  const handleLogoChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImageReview(review);
    setImage(img);
  };

  const handleCreateBrandSubmit = () => {
    const form = new FormData();
    console.log(image);
    form.append('name', brandName);
    form.append('logo', image);
    form.append('url', url);
    handleStartLoading()
    ConceptService.CreateBrandByConceptId(conceptId, form).then((res) => {
      setConcepts((prevState) =>
        prevState.map((concept) => {
          if (concept._id === res._id) {
            return res;
          }
          return concept;
        })
      );
      handleClose();
    }).finally(handleStopLoading);
  };

  const handleDeleteBrand = (idConcept, idBrand) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: 'Thao tác này không  thể hoàn tác',
      text: 'Bạn chắc chắn muốn xóa thương hiệu này',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Xóa',
      cancelButtonText: 'Hủy',
    }).then((result) => {
      if (result.isConfirmed) {
        handleStartLoading()
        ConceptService.DeleteBrand(idConcept, idBrand)
          .then((res) => {
            setConcepts((prevState) =>
              prevState.map((concept) => {
                if (concept._id === res._id) {
                  return res;
                }
                return concept;
              })
            );
            handleClose();
            Swal.fire('Thành công', ' Xóa thương hiệu thành công', 'success');
          })
          .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
          .finally(handleStopLoading)
      }
    });
  };

  const handleEditBrand = (name, url, urlBrand, idBrandd, idConceptt) => {
    setBrandName(name)
    setImageReview(`${process.env.REACT_APP_IMAGE}${url}`)
    setUrl(urlBrand)
    setEditBrand(true);
    setIdBrand(idBrandd)
    setIdConcept(idConceptt)
  }

  const handleDeleteConcept = (id) => {
    Swal.fire({
      customClass: {
        container: { zIndex: 999999 },
      },
      title: 'Thao tác này không  thể hoàn tác',
      text: 'Bạn chắc chắn muốn xóa concept này',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Xóa',
      cancelButtonText: 'Hủy',
    }).then((result) => {
      if (result.isConfirmed) {
        handleStartLoading()
        ConceptService.DeleteConcept(id)
          .then(() => {
            setConcepts((prevState) => prevState.filter((concept) => concept._id !== id));
            handleClose();
            Swal.fire('Thành công', ' Xóa concept thành công', 'success');
          })
          .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
          .finally(handleStopLoading)
      }
    });
  };

  const handleEditBrandd = () => {
    const form = new FormData();
    console.log(image);
    form.append('name', brandName);
    form.append('logo', image);
    form.append('url', url);
    handleStartLoading()
    ConceptService.EditBrand(idConcept, idBrand, form)
      .then((res) => {
        getConcept();
        handleCloseBrand()
        Swal.fire('Thành công', ' Cập nhật thương hiệu thành công', 'success');
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading)
  }

  const handleEnableConcept = (id) => {
    handleStartLoading()
    ConceptService.EnableConcept(id)
      .then(() => {
        setConcepts((prevState) =>
          prevState.map((concept) => {
            if (concept._id === id) concept.status = 'Active';
            return concept;
          })
        );
        enqueueSnackbar('Thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading)
  };

  const handleDisableConcept = (id) => {
    handleStartLoading()
    ConceptService.DisableConcept(id)
      .then(() => {
        setConcepts((prevState) =>
          prevState.map((concept) => {
            if (concept._id === id) concept.status = 'Inactive';
            return concept;
          })
        );
        enqueueSnackbar('Thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading)
  };

  const handleEditConceptSubmit = () => {
    handleStartLoading()
    ConceptService.EditConcept(conceptId, { name })
      .then(() => {
        setConcepts((prevState) =>
          prevState.map((concept) => {
            if (concept._id === conceptId) {
              concept.name = name;
              concept.status = 'Inactive';
            }
            return concept;
          })
        );
        enqueueSnackbar('Cập nhật thành công', 'success');
      })
      .then(() => handleClose())
      .catch((err) => enqueueSnackbar(err.response.data, 'error'))
      .finally(handleStopLoading)
  };

  return (
    <Page title="Concept">
      <Dialog open={openBrand} fullWidth maxWidth="sm" onClose={handleClose}>
        <DialogTitle>Thương hiệu</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            id="name"
            label="Tên thương hiệu"
            fullWidth
            variant="standard"
          />
          <TextField
            margin="dense"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            id="name"
            label="Url"
            fullWidth
            variant="standard"
          />

          <Button sx={{ border: '1px dashed gray' }} color="primary" aria-label="upload picture" component="label">
            <input onChange={handleLogoChange} hidden accept="image/*" type="file" />
            {imageReview ? (
              <img src={imageReview} alt="noimage" width={'300px'} height={'180px'} style={{ objectFit: 'cover' }} />
            ) : (
              <img
                src="/static/noimage.jpeg"
                alt="noimage"
                width={'300px'}
                height={'180px'}
                style={{ objectFit: 'cover' }}
              />
            )}
          </Button>
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleClose}>
            Hủy
          </Button>
          <Button variant={'outlined'} onClick={handleCreateBrandSubmit}>
            Thêm thương hiệu
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editBrand} fullWidth maxWidth="sm" onClose={handleClose}>
        <DialogTitle>Sửa thương hiệu</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            id="name"
            label="Tên thương hiệu"
            fullWidth
            variant="standard"
          />
          <TextField
            margin="dense"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            id="name"
            label="Url"
            fullWidth
            variant="standard"
          />

          <Button sx={{ border: '1px dashed gray' }} color="primary" aria-label="upload picture" component="label">
            <input onChange={handleLogoChange} hidden accept="image/*" type="file" />
            {imageReview ? (
              <img src={imageReview} alt="noimage" width={'300px'} height={'180px'} style={{ objectFit: 'cover' }} />
            ) : (
              <img
                src="/static/noimage.jpeg"
                alt="noimage"
                width={'300px'}
                height={'180px'}
                style={{ objectFit: 'cover' }}
              />
            )}
          </Button>
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleCloseBrand}>
            Hủy
          </Button>
          <Button variant={'outlined'} onClick={handleEditBrandd}>
            Sửa thương hiệu
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
        <DialogTitle>Concept</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            value={name}
            onChange={(e) => setName(e.target.value)}
            id="name"
            label="Tên concept"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleClose}>
            Hủy
          </Button>
          <Button variant={'outlined'} onClick={editMode ? handleEditConceptSubmit : handleCreateConceptSubmit}>
            {editMode ? 'Cập  nhật' : 'Thêm concept'}
          </Button>
        </DialogActions>
      </Dialog>
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Concept
          </Typography>

          <Button onClick={handleCreateConceptClick} variant="contained" startIcon={<Iconify icon="akar-icons:plus" />}>
            Thêm concept
          </Button>
        </Stack>
        <Divider sx={{ my: 5 }} />
        {concepts.map((concept) => (
          <Box sx={{ mb: 5 }} key={concept._id}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="h4" gutterBottom>
                  {concept.name}
                </Typography>

                {concept.status === 'Inactive' ? (
                  <Chip color="error" size="small" label="Không hoạt động" />
                ) : (
                  <Chip color="primary" size="small" label="Hoạt động" />
                )}
              </Stack>

              <Stack direction="row" spacing={1}>
                <Button color="error" size="small" onClick={() => handleDeleteConcept(concept._id)} variant="outlined">
                  Xóa
                </Button>
                <Button
                  color="info"
                  size="small"
                  onClick={() => handleEditClick(concept._id, concept.name)}
                  variant="outlined"
                >
                  Cập nhật
                </Button>

                {concept.status === 'Inactive' ? (
                  <Button onClick={() => handleEnableConcept(concept._id)} variant="outlined" size="small" color="info">
                    Kích hoạt
                  </Button>
                ) : (
                  <Button
                    color="warning"
                    size="small"
                    onClick={() => handleDisableConcept(concept._id)}
                    variant="outlined"
                  >
                    Ngừng hoạt động
                  </Button>
                )}
                <Button
                  variant="contained"
                  onClick={() => handleCreateBrandClick(concept._id)}
                  startIcon={<Iconify icon="akar-icons:plus" />}
                  size="small"
                >
                  Thêm thương hiệu
                </Button>
              </Stack>
            </Stack>
            <ImageList cols={8} gap={25}>
              {concept.brands &&
                concept?.brands.map((brand) => (
                  <ImageListItem key={brand._id}>
                    <img
                      style={{ objectFit: 'contain' }}
                      src={`${process.env.REACT_APP_IMAGE}${brand.logo}`}
                      alt={brand.brandName}
                    />
                    <ImageListItemBar
                      title={brand.brandName}
                      position="below"
                      actionIcon={
                        <Box sx={{ display: "flex" }}>
                          <IconButton
                            onClick={() => handleDeleteBrand(concept._id, brand._id)}
                            aria-label={`info about ${brand.brandName}`}
                          >
                            <Iconify icon="fluent:delete-24-regular" width={20} heigh={20} color={'#c0392b'} />
                          </IconButton>
                          <IconButton
                            onClick={() => handleEditBrand(brand.brandName, brand.logo, brand.url, brand._id, concept._id)}
                          // aria-label={`info about ${brand.brandName}`}
                          >
                            <Iconify icon="fluent:edit-24-regular" width={20} heigh={20} color={'#c0392b'} />
                          </IconButton>
                        </Box>
                      }
                    />
                  </ImageListItem>
                ))}
            </ImageList>
          </Box>
        ))}
      </Container>
    </Page>
  );
};

export default Concept;
